import * as angular from 'angular';

class SelectedList implements ng.IController {
}

angular.module('naut').component('selectedList', {
    template: require('./selected-list.component.html'),
    controller: SelectedList,
    controllerAs: 'ctrl',
    bindings: {
        onDelete: '&',
        items: '<',
        header: '<',
        displayField: '<',
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/nfc-stickers/shared/selected-list/selected-list.component.ts